<template>
  <div class="sidebar-page">
    <section class="sidebar-layout">
      <b-sidebar
        position="static"
        :mobile="mobile"
        :expand-on-hover="expandOnHover"
        :reduce="reduce"
        type="is-light"
        open
      >
        <div class="px-3 py-3">
          <b-menu class="is-custom-mobile">
            <b-menu-list label="Menu">
              <b-menu-item
                icon="certificate-outline"
                label="Certificates"
                @click="$router.push({ name: 'certificates' })"
                :active="
                  ['certificates', 'certificates.create'].indexOf(
                    $route.name
                  ) >= 0
                "
              >
              </b-menu-item>
            </b-menu-list>
            <b-menu-list label="Actions">
              <b-menu-item
                icon="logout"
                label="Logout"
                @click="signOut"
              ></b-menu-item>
            </b-menu-list>
          </b-menu>
        </div>
      </b-sidebar>
    </section>
  </div>
</template>

<script>
export default {
  data() {
    return {
      expandOnHover: false,
      mobile: "reduce",
      reduce: false
    };
  },
  methods: {
    signOut() {
      this.$auth.signOut();
    }
  }
};
</script>
